export default __webpack_public_path__ + "static/membership-control-9c82b79c485ca824b2527eca5ef71001.jpg";